import {apiConstructor} from '../api/ConstructorApi';

let cabinets = []


//init stands list

function initCabinets() {
    return new Promise((resolve, reject) => {
        apiConstructor.getCabinets()
        .then(res => {
            cabinets = res.data;
            resolve(res.data)
        })
        .catch(res => {
            reject(false)
        })
    })
}

export {cabinets, initCabinets} ;